import { getUserError } from '../../../../components/miscUtils';
import { TpDashboardActionContext, TpDbActionStepDefinition as TpDbActionStepTypeDefinition } from '../interfaces';

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'Set Chart Compound Aspect',
    description:
      'Binds a compound aspect of a chart to a new table column. Note that this can only be used for charts on a dashboard that are defined in a direct way in the template (and not e.g. via a gallery plot compound element)',
    properties: {
      type: { type: 'string', const: 'SetChartCompoundAspect' },
      chartId: {
        type: 'string',
        description: 'Identifier of the chart in the dashboad template for which a compund aspect should be modified.',
      },
      compoundAspect: {
        type: 'string',
        description: 'Specifies what compound aspect of the chart should be modified.',
      },
      colId: {
        type: 'string',
        description: 'Specifies to what table column this compound aspect should be bound to.',
      },
      method: {
        type: 'string',
        enum: ['replace', 'add', 'addIfAbsent', 'clear'],
        description: 'Specifies how the compound aspect binding should be modified (default: add).',
      },
    },
    required: ['type', 'chartId', 'compoundAspect', 'method'],
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  const chartTemplateId = step.chartId; // in the template action definition, the user enters the same chart id as for the definition of the chart in the template
  const chartIds = ctx.dashboardContext.getChartDefsFromTemplateId(chartTemplateId).map((chartDef) => chartDef.id);
  if (step.method !== 'clear' && !step.colId) {
    throw getUserError(`Setting a chart compound aspect requires a column ID`);
  }
  chartIds.forEach((chartId) => {
    ctx.dashboardContext.updateChartCompoundAspectBinding(
      chartId,
      step.compoundAspect,
      step.colId ?? '', // For typescript, always provide a string
      step.method,
    );
  });
  onCompleted();
}

const dbActionStepSetChartCompoundAspect: TpDbActionStepTypeDefinition = {
  stepType: 'SetChartCompoundAspect',
  execute,
  getJsonSchema,
};

export default dbActionStepSetChartCompoundAspect;
